import type { AppStatus_Realworks_FullExcludingKenmerkenSync__KenmerkMapping__Input } from '~/graphql/types';
import type { KenmerkLookup } from '../../types';
import flattenKenmerkLookup from '../flattenKenmerkLookup';

const transformFrontendKenmerken_FullExcludingKenmerken = (
  kenmerkLookup: KenmerkLookup | null,
): Array<AppStatus_Realworks_FullExcludingKenmerkenSync__KenmerkMapping__Input> =>
  flattenKenmerkLookup(kenmerkLookup).map(({ id, tag, checked }) => ({
    realworksKenmerkId: id,
    // We cannot send a tag when checked is true due to backend's validation, so we send null
    tag: checked ? null : tag,
    exclude: checked,
  }));

export default transformFrontendKenmerken_FullExcludingKenmerken;
